export const openCreateTaskSidebar = {
  methods: {
    openCreateTaskSidebar() {
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right-tasks');
        }, 0)
    },
  }
}